import { useGT } from 'gt-react';
import type { FeedbackKind, FeedbackStatus } from '@erp/shared-types';

/** Translated status labels, keyed by the stored value. */
export function useFeedbackStatusLabel(): (status: string) => string {
  const gt = useGT();
  const labels: Record<FeedbackStatus, string> = {
    new: gt('New', { context: 'feedback status' }),
    in_triage: gt('In Review', { context: 'feedback status' }),
    backlog: gt('Backlog', { context: 'feedback status' }),
    done: gt('Done', { context: 'feedback status' }),
    canceled: gt('Canceled', { context: 'feedback status' }),
    duplicate: gt('Duplicate', { context: 'feedback status' }),
  };
  return (status) => labels[status as FeedbackStatus] ?? status;
}

/** Translated kind labels, keyed by the stored value. */
export function useFeedbackKindLabel(): (kind: string) => string {
  const gt = useGT();
  const labels: Record<FeedbackKind, string> = {
    bug: gt('Bug', { context: 'feedback kind' }),
    feature_request: gt('Feature Request', { context: 'feedback kind' }),
    question: gt('Question', { context: 'feedback kind' }),
    other: gt('Other', { context: 'feedback kind' }),
  };
  return (kind) => labels[kind as FeedbackKind] ?? kind;
}
